<ng-container *ngIf="!this.task; else InsideBaseTask">
  <div class="wrapper wrapper-content">
    <div class="container-fluid">
      <div class="row" *ngIf="loaded">
        <ng-container *ngIf="questions && questions.length > 0; else emptyQuestions">
          <ng-container *ngTemplateOutlet="questionTemplate"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #InsideBaseTask>
  <ng-container *ngTemplateOutlet="questionTemplate"></ng-container>
</ng-template>
<ng-template #questionTemplate>
  <p-accordion [multiple]="true" class="mt-2 col-12" [activeIndex]="activeTabs">
    <ng-container *ngIf="getNumberOfNotAnswered() > 0; else allAnswered">
      <div class="col-12 alert alert-warning mb-4">
        <i class="fas fa-1-5x fa-exclamation-circle m-r-md"></i>
        <span>{{ 'ProjectQuestions.pendingQuestions' | translate}}</span>
      </div>
    </ng-container>
    <ng-container *ngFor="let questionBean of questions">
      <p-panel styleClass="mb-3" [toggleable]="true" [collapsed]="!(questionBean.status === QuestionState.EDITING)">
        <p-header class="w-100">
          <div class="status col-11 col-xs-10  d-inline-block" [ngClass]="'status-' + questionBean.status">
            <span class="value">{{questionBean?.question?.startDate | date:'dd/MM/yyyy HH:mm:ss'}}: </span>
            <span class="value">{{questionBean?.question?.sender?.company?.taxIdentifier}} - </span>
            <span class="value">{{questionBean?.question?.sender?.company?.name}}</span>
          </div>
          <span class="badge badge-danger text-left"
            *ngIf="questionBean.status === QuestionState.PENDING">{{'ProjectQuestions.state.PENDING' |
            translate}}</span>
          <span class="badge badge-warning text-left"
            *ngIf="questionBean.status === QuestionState.EDITING">{{'ProjectQuestions.state.EDITING' |
            translate}}</span>
          <span class="badge badge-success text-left"
            *ngIf="questionBean.status === QuestionState.SENDED">{{'ProjectQuestions.state.SENDED' | translate}}</span>
          <span class="badge badge-secondary text-left"
            *ngIf="questionBean.status === QuestionState.SENDING">{{'ProjectQuestions.state.SENDING' |
            translate}}</span>
        </p-header>
        <div class="form-group col-12 questionBody">
          <label for="questionBody" class="mt-2 font-bold">{{ 'ProjectQuestions.question' | translate }}:</label>
          <!--div class=" p-inputgroup">
            <textarea id="questionBody" disabled="disabled" [(ngModel)]="questionBean.question.body"
              class="plForm-element form-control NOEDITABLE" name="questionBody">
          </textarea-->
          <div class="p-inputgroup">
            <div class="value" [innerHTML]="questionBean.question.body"></div>
          </div>
        </div>
        <div class="responseDate col-12">
          <span class="label mt-2 font-bold"> {{'ProjectQuestions.response' | translate}}: </span>
          <span class="ml-2 value"
            *ngIf="questionBean.status === QuestionState.SENDED">{{questionBean.response.sendedDate | date:'dd/MM/yyyy
            HH:mm:ss'}}</span>
        </div>
        <div class="form-group col-12 response" *ngIf="questionBean.status > QuestionState.PENDING">
          <div class="p-inputgroup">
            <div class="value" [innerHTML]="(questionBean.response) ? questionBean.response.body : ''"></div>
          </div>
        </div>
        <div class="flex-row py-2">
          <div class="d-flex flex-row-reverse">
            <!-- <button class="btn btn-sm btn-outline-primary float-right" (click)="this.modify(questionBean)" appNoDblClick
              title="Responder" *ngIf="questionBean.response">
              <i class="fas fa-plus"></i>
              Modificar Respuesta
            </button> -->
            <button class="btn btn-sm btn-outline-primary float-right" (click)="this.editQuestion(questionBean)"
              appNoDblClick title="Responder"
              *ngIf="questionBean.status !== QuestionState.SENDED && questionBean.status !== QuestionState.SENDING">
              <ng-container *ngIf="questionBean.status === QuestionState.EDITING">
                <i class="fas fa-pencil-alt"></i> {{'General.edit' | translate}} respuesta</ng-container>
              <ng-container *ngIf="questionBean.status === QuestionState.PENDING">
                <i class="fas fa-plus"></i> {{'ProjectQuestions.reply' | translate}} </ng-container>
            </button>
          </div>
        </div>
      </p-panel>
    </ng-container>
  </p-accordion>
</ng-template>
<ng-template #emptyQuestions>
  <div class="alert alert-info col-12 p-md">
    <i class="fas fa-lg fa-info-circle"></i> <span class="m-l-md">{{'ProjectQuestions.noData' | translate}}</span>
  </div>
</ng-template>
<ng-template #allAnswered>
  <div class="col-12 alert alert-info mb-4">
    <i class="fas fa-1-5x fa-info-circle m-r-md"></i>
    <span>{{ 'ProjectQuestions.allAnswered' | translate}}</span>
  </div>
</ng-template>